module.exports = __webpack_public_path__ + "static/TwitchPolls-5cedf49008abe8f6d5bdde0f26445a7c.mp4";